export const SEARCH_BAR_INPUT_STATE = {
    INITIAL: 'INITIAL',
    COLLAPSED: 'COLLAPSED',
    EXPANDED: 'EXPANDED',
};
